import { Content, Title } from './toggle.styled';

export const Toggle = (props) => {
  const { label, label2, theme, setOne, setTwo, ...rest } = props;
  const name = rest.name;

  const setTypeOne = () => {
    if (!setOne) {
      return;
    }
    setOne();
  };

  const setTypeTwo = () => {
    if (!setTwo) {
      return;
    }
    setTwo();
  };

  return (
    <Content>
      {label && (
        <Title className="label1" onClick={setTypeOne}>
          {label}
        </Title>
      )}
      <label>
        <input id={name} type="checkbox" value="1" {...rest} className={`toggle-input ${rest.className || ''}`} />
        <span />
      </label>
      {label2 && (
        <Title className="label2" onClick={setTypeTwo}>
          {label2}
        </Title>
      )}
    </Content>
  );
};
